export * from "./InventoryDetailsCard";
